import {ValidationErrors, ValidatorFn, AbstractControl} from '@angular/forms';
import {
  EMPLOYEE_PRODUCT_EMAIL_FOR_VALIDATION,
  PRIMARY_APPLICANT_EMAIL,
  CO_APPLICANT_EMAIL,
  EMPLOYEE_PRODUCT_EMAIL_VALIDATION_MESSAGE,
  ADDRESS_VALIDATION_MESSAGE,
  HOUSENUMBER_VALIDATION_MESSAGE,
  PRIMARY_APPLICANT_LAST_NAME,
  CO_APPLICANT_LAST_NAME
} from "src/app/shared/constants";

export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp supplied
      const valid = regex.test(control.value);

      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    if (control != null) {
      const password: string = control.get('password')?.value; // get password from our password form control
      const confirmPassword: string = control.get('confirmPassword')?.value; // get password from our confirmPassword form control
      // compare is the password math
      if (password === null || password === undefined || password == '' || password !== confirmPassword) {
        // if they don't match, set an error in our confirmPassword form control
        control.get('confirmPassword')?.setErrors({NoPassswordMatch: true});
      } else {
        control.get('confirmPassword')?.setErrors(null);
      }
    }
  }

  static POBoxValidator(error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      // test the value of the control against the regexp for PO Box addresses
      const invalid = (new RegExp('\\b[P|p]*(OST|ost)*\\.*\\s*[O|o|0]*(ffice|FFICE)*\\.*\\s*[B|b][O|o|0][X|x]\\b')).test(control.value);

      // if true, return error passed as parameter, else return no error
      return invalid ? error : null;
    };
  }

  static socialSecurityNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (control === null || control.value === null) return null;

    let ssn: string = control.value;

    // Remove format characters '-', '_'
    ssn = ssn.replace(/\-/gi, '');
    ssn = ssn.replace(/\_/gi, '');

    // Once actual value determined - get length
    let lengthInvalid: boolean = false;
    if (ssn.length !== 9)
      lengthInvalid = true;

    if (lengthInvalid)
      return {'invalidSsnRange': true};

    // Reject SSN area range 900-999 as invalid for US SSNs.
    if (ssn.startsWith('9'))
      return {'invalidSsnRange': true};

    //  Regular expression to check for a String containing all the same character.
    //  Ex: 111-11-1111
    const isAllDuplicateCharacters = (new RegExp('^(.)\\1*$')).test(ssn);

    if (isAllDuplicateCharacters)
      return {'invalidSsnRange': true};

    return null;
  }


  static emailAddressValidator(control: AbstractControl): ValidationErrors | null {
    if (control === null || control.value === null) return null;
    let emailAddress: string = control.value;
    let isPrimary = control.parent?.value.isPrimary;

    var lastIndexOfEmailAtSymbol = emailAddress.lastIndexOf("@");
    var stringAfterAtSymbol = emailAddress.substring(lastIndexOfEmailAtSymbol + 1);

    let isInvalidEmail: boolean = false;

    // validate email is in anystring@anystring.anystring pattern
    const pattern = /^\S+@\S+\.\S+$/;
    if (!pattern.test(emailAddress)) {
      isInvalidEmail = true;
    }

    if(emailAddress.includes('+')){
      isInvalidEmail = true;
    }

    if (!isInvalidEmail) {
      return null;
    }

    let message = EMPLOYEE_PRODUCT_EMAIL_VALIDATION_MESSAGE;

    message += isPrimary
      ? ` in ${PRIMARY_APPLICANT_EMAIL}`
      : ` in ${CO_APPLICANT_EMAIL}`;

    return {message};
  }

  static AddressLine1Validator(control: AbstractControl): ValidationErrors | null {

    if (control === null || control.value === null) return null;

    const addressParts = control.value.trim().split(' ');

    switch (addressParts.length) {
      case 0:
      case 1:
        return { message: ADDRESS_VALIDATION_MESSAGE };

      // success case
      default:
        const houseNumber = addressParts[0].trim();

        let houseNumberValid = /([0-9])([a-zA-Z0-9])*$/.test(houseNumber);

        if (!houseNumberValid) return { message: HOUSENUMBER_VALIDATION_MESSAGE };

        return null;
    }
  }

  static applicantNameSpecialCharacterValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const pattern = /^[a-zA-Z0-9.'\s-]+$/;
    if (pattern.test(control.value)) {
      return null;
    }

    return {'valid': true};
  }

  static PhoneNumberValidation(control: AbstractControl): ValidationErrors | null {
    if (control === null || control.value === null) return null;
    let isPrimary = control.parent?.value.isPrimary;
    const pattern = new RegExp("^[1-9][0-9]*$");
    let valid =  pattern.test(control.value);

    if(control.value.length > 0 && !control.value) valid = false;
    if (valid) return null;

    return {'valid': true};
  }

}
